var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'jquery', 'underscore', 'backbone', 'app-common/component/commenting', 'app-common/collection/note', 'app-common/component/note', 'app-common/template/notes/notes.htm', 'common/lib/jquery.hotkeys'], function(core, $, _, Backbone, Commenting, NoteCollection, NotesItemView, notesTemplate) {
  var NotesView;
  return NotesView = (function(_super) {

    __extends(NotesView, _super);

    function NotesView() {
      this.renderItem = __bind(this.renderItem, this);
      NotesView.__super__.constructor.apply(this, arguments);
    }

    NotesView.prototype.className = 'bl-notes-container';

    NotesView.prototype.template = _.template(notesTemplate);

    NotesView.prototype.events = {
      'click .bl-notes__post-note-btn': 'handlePostCreate',
      'focus [name="reply-input"]': 'showSubmit',
      'blur [name="reply-input"]': 'hideSubmit',
      'mousedown .bl-notes__post-note-btn': 'preventHideSubmit'
    };

    NotesView.prototype.$list = function() {
      return this.$('.bl-notes__list');
    };

    NotesView.prototype.$input = function() {
      return this.$('.bl-notes__note-input');
    };

    NotesView.prototype.$controls = function() {
      return this.$('.controls');
    };

    NotesView.prototype.$postNoteBtn = function() {
      return this.$('.bl-notes__label');
    };

    NotesView.prototype.initialize = function(_arg) {
      var $container, internalNotes, ledgerId, syncNotes;
      $container = _arg.$container, internalNotes = _arg.internalNotes, syncNotes = _arg.syncNotes, ledgerId = _arg.ledgerId;
      this._syncNotes = syncNotes || _.noop;
      this.initializeCollections(internalNotes, ledgerId);
      this.bindEvents();
      this.render($container);
      return NotesView.__super__.initialize.apply(this, arguments);
    };

    NotesView.prototype.initializeCollections = function(internalNotes, ledgerId) {
      if (internalNotes == null) {
        internalNotes = [];
      }
      this.collection = new NoteCollection(internalNotes);
      if (ledgerId) {
        this.ledgerId = ledgerId;
        return this.collection.fetchByLedgerId(ledgerId);
      }
    };

    NotesView.prototype.bindEvents = function() {
      this.listenTo(this.collection, 'add', this.renderItem);
      return this.listenTo(this.collection, 'modelUpdate remove', this.saveNotes);
    };

    NotesView.prototype.bindHotkeys = function() {
      var _ref, _ref1,
        _this = this;
      return $(this.el).off().on('keydown', (_ref1 = this.$input()) != null ? _ref1.selector : void 0, 'ctrl+return', function(e) {
        e.preventDefault();
        return _this.handlePostCreate(e);
      }).on('keydown', (_ref = this.$input()) != null ? _ref.selector : void 0, function(e) {
        return e.stopPropagation();
      });
    };

    NotesView.prototype.handlePostCreate = function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return this.createInternalNote();
    };

    NotesView.prototype.createInternalNote = function() {
      var $input, body, user;
      $input = this.$input();
      body = this.getText($input);
      if (body.length === 0) {
        return;
      }
      $input.empty();
      user = core.getCurrentUser();
      this.collection.add({
        userId: core.getCurrentUserid(),
        body: this.sanitize(body),
        flagged: false,
        userFirstName: user.get('firstName'),
        userLastName: user.get('lastName')
      });
      if (this.ledgerId) {
        return this.collection.saveLedgerNotes(this.ledgerId);
      } else {
        return this.saveNotes();
      }
    };

    NotesView.prototype.saveNotes = function() {
      if (this.ledgerId) {
        return this.collection.saveLedgerNotes(this.ledgerId);
      } else {
        return this._syncNotes(this.collection.toJSON());
      }
    };

    NotesView.prototype.showSubmit = function() {
      if (!this.disableShowSubmit) {
        return this.$input().addClass('highlighted');
      }
    };

    NotesView.prototype.hideSubmit = function() {
      if (!this.disableHideSubmit) {
        this.$input().removeClass('highlighted');
      }
      return this.disableHideSubmit = false;
    };

    NotesView.prototype.preventHideSubmit = function(e) {
      var _ref;
      return this.disableHideSubmit = ((_ref = this.$input()) != null ? _ref[0] : void 0) === e.target;
    };

    NotesView.prototype.preventShowSubmit = function() {
      return this.disableShowSubmit = true;
    };

    NotesView.prototype.renderItem = function(model) {
      var noteItem;
      noteItem = new NotesItemView(model);
      return this.$list().append(noteItem.el);
    };

    NotesView.prototype.render = function($container) {
      $container && this.setElement($container);
      this.$el.html(this.template, {});
      this.bindHotkeys();
      this.delegateEvents();
      _.each(this.collection.models, this.renderItem);
      return this.$el;
    };

    return NotesView;

  })(Commenting);
});
